// extracted by mini-css-extract-plugin
export default {"link":"_14mt88DiF6"};
    if(module.hot) {
      // 1625219397621
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  